exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#planning-absences .inp-calendrier .body-scroll-left,#planning-absences .inp-calendrier .body-scroll-right{max-height:inherit}#planning-absences .inp-calendrier .click{cursor:pointer!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2bbc7710","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/planningAbsences/unscoped.scss
// module id = vEYZ
// module chunks = 2